import style from "./style.module.scss";
import Header from "@/src/components/elements/Header";
import AppBar from "@/src/components/elements/AppBar";

export default function HomeLayout({
  tab = "/jadwal-saya",
  children,
  menus,
  text = "Profile",
  height,
}: {
  tab: any;
  children?: React.ReactNode;
  menus?: { [key: string]: string }[];
  text?: string;
  height?: number;
}): JSX.Element {
  const onRoute = (link: any) => {
    window.location.assign(link);
  };

  return (
    <>
      <Header withBack={false} text={text} />
      <div
        className={style.container}
        style={{
          padding: tab?.includes("filter") ? "0px" : "2rem 1rem 0 1rem",
          height: `${height}px`,
        }}
      >
        {children}
      </div>
      <AppBar active={tab} onClick={onRoute} datas={menus} />
    </>
  );
}
